module.exports = __webpack_public_path__ + "static/media/camida.b07af7b1.png";